/**
 * @packageDocumentation
 * @module f1/string
 */

const nonWordParts = /[^0-9a-z]/gi;
const dashesDudupe = /-+/g;
const firstDash = /^-/;
const lastDash = /-$/;

export interface Slug {
  /**
   * Convert words formatted as variables to English words
   *
   * @public
   * @function f1.slug
   * @param s a word, variable, or class to a slug
   * @example
   *
   * ```ts
   * f1.slug('__word_is.on-text') === 'word-is-on-text'
   * ```
   */
  (s: string): string;
}

/**
 * @see Slug
 */
export default (s: string): string => {
  return `${s}`
    .replace(nonWordParts, '-')
    .replace(dashesDudupe, '-')
    .replace(firstDash, '')
    .replace(lastDash, '')
    .toLowerCase()
    .trim();
};
